import "$styles/index.css"
import "$styles/syntax-highlighting.css"
import "./cookieconsent.js"

import components from "$components/**/*.{js,jsx,js.rb,css}"

document.addEventListener("DOMContentLoaded", function () {
  var menuButton = document.getElementById("menuButton");
  if (menuButton) {
    menuButton.addEventListener("click", function (e) {
      e.preventDefault();
      document.getElementById("header").classList.toggle("menuOpen");
    });
  }
});
